import { render, staticRenderFns } from "./OemGuardV2.vue?vue&type=template&id=470646ba&scoped=true"
import script from "./OemGuardV2.vue?vue&type=script&lang=js"
export * from "./OemGuardV2.vue?vue&type=script&lang=js"
import style0 from "./OemGuardV2.vue?vue&type=style&index=0&id=470646ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470646ba",
  null
  
)

export default component.exports